import Hammer from 'hammerjs'

export const mobileTabletLongPress = () => {
    if ($('.shopper-actions .btn').length > 0 && $('html').hasClass('no-desktop')) {
        var elements = document.getElementsByClassName('btn');
        [].slice.call(elements).forEach(function(element) {
            var hammertime = new Hammer(element);
            hammertime.on('press', function(event) {
                $(element).trigger('click');
            });
        });
    }
};
